import { Link, useLocation } from 'react-router-dom';
import { useState } from 'react';
import { categories } from '@/mocks/videoData';

export default function Navbar() {
  const [searchTerm, setSearchTerm] = useState('');
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchTerm.trim()) {
      window.REACT_APP_NAVIGATE(`/search?q=${encodeURIComponent(searchTerm.trim())}`);
      setSearchTerm('');
    }
  };

  return (
    <header className="sticky top-0 z-50 bg-background-50/95 backdrop-blur-md border-b border-background-200/60">
      <nav className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 flex-shrink-0">
            <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-play-circle-fill text-xl text-background-50"></i>
            </div>
            <span className="font-heading text-lg font-bold text-foreground-900 whitespace-nowrap">福利视频导航</span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 text-sm rounded-md transition-colors whitespace-nowrap ${
                location.pathname === '/' ? 'bg-primary-100 text-primary-700 font-medium' : 'text-foreground-600 hover:bg-background-100 hover:text-foreground-900'
              }`}
            >
              首页
            </Link>
            {categories.slice(0, 5).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 text-sm rounded-md transition-colors whitespace-nowrap ${
                  location.pathname.includes(cat.slug) ? 'bg-primary-100 text-primary-700 font-medium' : 'text-foreground-600 hover:bg-background-100 hover:text-foreground-900'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2 text-sm rounded-md transition-colors whitespace-nowrap ${
                location.pathname === '/about' ? 'bg-primary-100 text-primary-700 font-medium' : 'text-foreground-600 hover:bg-background-100 hover:text-foreground-900'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <form onSubmit={handleSearch} className="relative">
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="搜索视频资源..."
                className="w-48 lg:w-56 h-9 pl-9 pr-3 text-sm rounded-full border border-background-300 bg-background-100 text-foreground-900 placeholder-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
              />
              <button type="submit" className="absolute left-0 top-0 h-9 w-9 flex items-center justify-center text-foreground-400 hover:text-primary-500">
                <i className="ri-search-line text-sm"></i>
              </button>
            </form>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 hover:text-foreground-900"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden border-t border-background-200 py-3 pb-4">
            <form onSubmit={handleSearch} className="mb-3">
              <div className="relative">
                <input
                  type="text"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  placeholder="搜索视频资源..."
                  className="w-full h-10 pl-10 pr-4 text-sm rounded-lg border border-background-300 bg-background-100 text-foreground-900 placeholder-foreground-400 focus:outline-none focus:border-primary-400"
                />
                <button type="submit" className="absolute left-0 top-0 h-10 w-10 flex items-center justify-center text-foreground-400">
                  <i className="ri-search-line text-sm"></i>
                </button>
              </div>
            </form>
            <div className="flex flex-col gap-1">
              <Link to="/" onClick={() => setMobileOpen(false)} className="px-4 py-2.5 text-sm rounded-md text-foreground-700 hover:bg-background-100">首页</Link>
              {categories.slice(0, 6).map((cat) => (
                <Link key={cat.slug} to={`/category/${cat.slug}`} onClick={() => setMobileOpen(false)} className="px-4 py-2.5 text-sm rounded-md text-foreground-700 hover:bg-background-100">{cat.name}</Link>
              ))}
              <Link to="/about" onClick={() => setMobileOpen(false)} className="px-4 py-2.5 text-sm rounded-md text-foreground-700 hover:bg-background-100">关于我们</Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}